import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getRacePredictorSlice = createSlice({
    name: 'RacePredictor',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchRacePredictor.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchRacePredictor.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE
            })
            .addCase(fetchRacePredictor.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            })
    }
});

export const { setRacePredictor, setStatus } = getRacePredictorSlice.actions;
export default getRacePredictorSlice.reducer;

export const fetchRacePredictor = createAsyncThunk('/RacePredictor2/fetch', async ({ id }) => {
    const res = await axios.get(`${getBaseUrl()}/PredictorForCompleteHorses/${id}`);
    const RacePredictorData = res.data;
    return RacePredictorData.data;
})